import axios from 'axios'

export function getAgreement(pageId: number | string) {
  return axios.get<string>(`/api/pages/user-agreement/${pageId}`)
}
